import React, {useState, useEffect, useLayoutEffect, useRef} from 'react';
import './ret.css';
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';


const Nodal = ({is, isOpen, onClose, onConfirm, message }) => {

    useEffect(()=>{
        if(isOpen){
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        }else{
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        };
    
        return () => {
          document.body.style.overflow = 'unset';
          document.body.style.paddingRight = '0px';
        };
      }, [isOpen]);

    if (!isOpen) return null;
  
    return (
      <div className="nodal-overlay" onClick={onClose}>
        <div className="nodal-content" onClick={(e) => e.stopPropagation()}>
          <h3>확인 필요</h3>
          <p>{message}</p>
          <div className="nodal-buttons">
            <button className="cbtn" onClick={onClose}>취소</button>
            <button className="dbtn" onClick={onConfirm}>{is == "sakj" ? "삭제" : "로그인"}</button>
          </div>
        </div>
      </div>
    );
  };

const Minis =({keun, moar, woar, cons, dayr, editt,gare,rehello})=>{
    const komai = useRef(null);
    const [more, setmore] = useState(false);
    const [expn, setexpn] = useState(false);
    const furi = useSelector(state=>state.mahena);

    const mangt = {
        WebkitLineClamp: expn ? 'unset' : 4
    };
    
    useEffect(()=>{
       
        if(komai.current){
            const {scrollHeight, clientHeight} = komai.current;
          
            if(scrollHeight > clientHeight){
               
            setmore(true);
        };
    };
    },[cons]);

    const morelong = ()=>{
        setexpn(!expn);
    };

    return(  
        <div className={isMobile ? moar : woar} id={cons.num}>
        <div className={isMobile ? 'mdaegu' : 'daegu'}>
        <span className='daegk1'>{cons.name}</span>
        <span className='daegk2'>{dayr}</span>
        {cons.ban !== 1 && <span className='daegk3' onClick={(ev)=>rehello(cons.parent, cons.num, ev)}>&#x21B3;</span>}
        {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(vv)=>editt(cons.parent, cons.num, cons.content, vv)}>&#x270E;</span>}
        {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(cc)=>{gare(cc, cons.num)}}>&#x1F5D1;</span>}
        </div>
        <p className={cons.ban == 1 ? 'daegk4 daegb' : 'daegk4'} ref={komai} style={mangt}>{cons.content}</p>
        {more && <p onClick={morelong} className='macid'>{expn ? '접기' : '다보기'}</p>}
    </div>
    );
};  

const Eoon =()=>{
    const {way : jikap} = useParams();
    const neyong = useLocation();
    const ngate = useNavigate();
    const [pac, setpac] = useState();
    const [pag, setpag] = useState({});
    const [addnum, setaddnum] = useState(1);
    const [momo, setmomo] = useState(neyong.state);
    const [ruru, setruru] = useState(0);
    const [dae, setdae] = useState(false);
    const [gamsa, setgamsa] = useState(false);
    const [siod, setsiod] = useState(null);
    const furi = useSelector(state=>state.mahena);
    const [single, setsingle] = useState(window.history.state.page == undefined || window.history.state.page == null ? 1 : window.history.state.page);
    // const komai = useRef(null);
    // const [more, setmore] = useState(false);
    // const [expn, setexpn] = useState(false);

    let subma = false; 
    const kono = async (e)=>{
        e.preventDefault();
        if(subma){return;};
      
        if(!furi?.id){
            setgamsa(true);
            return;
        };
  
        const fortoday = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const diver = document.getElementById('kooo').innerText;
        // const diver = iver.replace(/<[^>]*>?/gm, '');
        if(!diver.trim()){
            alert("내용을 작성해주세요.");
            return;
        };
        if(Array.from(diver.trim()).length > 500){
            alert("500자 이하로 작성해주세요.");
            return;
        };

        const shot = new FormData();
        shot.append('name', furi.id);
        shot.append('nyid', jikap);
        shot.append('parent', 0);
        shot.append('daytime', fortoday);
        shot.append('content', diver);

        subma = true;
        const sbut = document.querySelector('#mylif');
        sbut.classList.add('pith');
    
        const oiu = await axios.post('/api/daet',shot, {headers: {"Content-Type" : "multipart/form-data"}})
        .then(eah=>{ if(eah.data){setruru(prev=>prev+1);} }).catch(err=>{
            
            if(err.response && err.response.status === 400){
            const { code, message } = err.response.data;
            switch (code) {
        case "EMPTY_CONTENT":
          alert(message);
          break;

        case "MAX_LENGTH":
          alert(message);
          break;

        default:
          alert(message || "잘못된 요청입니다.");
      };
            };}).finally(()=>{
            subma = false;
            sbut.classList.remove('pith');});
            document.getElementById('kooo').innerHTML = '';
    };

let zubma = false;
const koco = async (e)=>{
    e.preventDefault();
    if(zubma){return;};
   
    if(!furi?.id){
        setgamsa(true);
       
        return;};
  
    const fortoday = dayjs().format("YYYY-MM-DD HH:mm:ss");
    const diver = document.getElementById('maaa').innerText;
    // const diver = iver.replace(/<[^>]*>?/gm, '');
    if(!diver.trim()){
        alert("내용을 입력해주세요.");
        return;
    };
    if(Array.from(diver.trim()).length > 500){
        alert("500자 이하로 작성해주세요.");
        return;
    };
    const shot = new FormData();
    shot.append('name', furi.id);
    shot.append('nyid', jikap);
    shot.append('parent', parseInt(e.currentTarget.dataset.mame) !== 0 ? e.currentTarget.dataset.mame : e.currentTarget.dataset.name);
    shot.append('daytime', fortoday);
    shot.append('content', diver);

    zubma = true;
    const sbut = document.querySelector('#myca');
    sbut.classList.add('pith');
    
    const oiu = await axios.post('/api/daet',shot, {headers: {"Content-Type" : "multipart/form-data"}})
        .then(eah=>{ if(eah.data){setruru(prev=>prev+1);} }).catch(err=>{console.log("대댓글패");}).finally(()=>{
            zubma = false;
            sbut.classList.remove('pith');});
            document.getElementById('maaa').innerHTML = '';
            document.querySelector('.ants').remove();
    };

    let cubma = false;
const kaca = async (e)=>{
    e.preventDefault();
    e.stopPropagation();
    if(cubma){return;};
 
    if(!furi?.id){
        setgamsa(true);
        return;
    };
   
    const diver = document.getElementById('mbbb').innerText;
    // const diver = iver.replace(/<[^>]*>?/gm, '');
    if(!diver.trim()){
        alert("내용을 작성해주세요.");
        return;
    };
    if(Array.from(diver.trim()).length > 500){
        alert("500자 이하로 작성해주세요.");
        return;
    };
    const shot = new FormData();
    shot.append('content', diver);
    shot.append('ssoo', e.currentTarget.dataset.name);    
    cubma = true;
    const sbut = document.querySelector('#mycb');
    sbut.classList.add('pith');
    
    // const nexu = e.currentTarget.closest('.daegu');
    const nexu = e.currentTarget.closest('.kants');
    const onara = document.createElement('p');
    onara.textContent = diver;
    onara.className = "daegk4";

   
    const oiu = await axios.post('/api/daetu',shot, {headers: {"Content-Type" : "multipart/form-data"}})
        .then(eah=>{ if(eah.data){setruru(prev=>prev+1);} }).catch(err=>{
            if(err.response && err.response.status === 400){
                const { code, message } = err.response.data;
                switch (code) {
            case "EMPTY_CONTENT":
              alert(message);
              break;
    
            case "MAX_LENGTH":
              alert(message);
              break;
    
            default:
              alert(message || "잘못된 요청입니다.");
          };
                };
        }).finally(()=>{
            cubma = false;
            sbut.classList.remove('pith');
            document.getElementById('mbbb').innerHTML = '';
            // nexu.insertAdjacentElement('afterend', onara);
            // document.querySelector('.ants').remove();
            nexu.replaceWith(onara);
        });
    };

    let lastword = null;
    const rehello = (e,a,ev)=>{
        ev.preventDefault();
        ev.stopPropagation();
        if (!window.location.href.includes('/eika')) {
            document.querySelector('.ants').remove();
            return; 
        };
       
        if(document.querySelector('.ants')){
            document.querySelector('.ants').remove();
            
        };

        if(lastword == null){
            ev.currentTarget.innerText = "\u21BA";
            lastword = ev.currentTarget;
        }else if(lastword == ev.currentTarget){
            ev.currentTarget.innerText = "\u21B3";
            lastword = null;
            
            // document.querySelector('.ants').remove();
            ev.currentTarget.closest('.ants').remove();
        }else{
            lastword.innerText = "\u21B3";
            ev.currentTarget.innerText = "\u21BA";
            lastword = ev.currentTarget;
        };

        const tar = document.getElementById(a);
       
        const newDiv = document.createElement('div');
        newDiv.className = "ants";
        const kohoa = document.createElement('div');
        if(isMobile){
            kohoa.className = 'mkohoa';
        }else{
            kohoa.className = 'kohoa';
        };

        const kooo = document.createElement('div');
        kooo.id = 'maaa';
        kooo.className = 'kohob';
        kooo.contentEditable = 'true';
        if(furi?.id){
            kooo.setAttribute('placeholder', '무관한 내용은 삭제될 수 있으니 유의해주세요!');
        }else{
            kooo.setAttribute('placeholder', '작성 전 로그인이 필요해요!');
            kooo.onmousedown = (e)=>{
                e.preventDefault();
                setgamsa(true);
            };
        };

        const myca = document.createElement('div');
        myca.id = 'myca';
        myca.className = 'kohoc1';
        myca.dataset.name = a;
        myca.dataset.mame = e;
        myca.addEventListener('click', koco); 


        const pTag = document.createElement('p');
        pTag.textContent = '답글하기';
        pTag.className = isMobile ? 'mdapgo' : 'dapgo';
        myca.appendChild(pTag);

        kohoa.appendChild(kooo);
        kohoa.appendChild(myca);
        newDiv.appendChild(kohoa);
        tar.insertAdjacentElement('afterend', newDiv);

        
    };

    useEffect(()=>{
        const fetch = async()=>{
            const hoakin = await axios.get(`/api/eiei?single=${jikap}`).then(kip=>{setpac(kip.data); })
            .catch(err=>console.log("페이지네이션 오류"));
        };
        fetch();
        
        const pras = new URLSearchParams(neyong.search);
        const sco = pras.get('scol') || '0';
        window.scrollTo({top:sco, behavior:'smooth'});
        
        document.title = momo?.title + " - 돌파공모"
       
    },[jikap]);

    useEffect(()=>{
        
        return ()=>{
            if(document.querySelector('.ants')){
                document.querySelector('.ants').remove();
            };
        };
    },[]);

    useLayoutEffect(()=>{
    
        const fetca = async()=>{
            const kakad = await axios.get(`/api/eonja?single=${jikap}`).then(kp =>{setmomo(kp.data); }).catch(err=>console.log("혼자요루"));
        };
        fetca();
        
        window.scrollTo(0,0);
        document.title = momo?.title + " - 돌파공모"
        
       
    },[jikap]);

    useLayoutEffect(()=>{
        const fetch = async()=>{
            const hoakin = await axios.get(`/api/daetr?single=${single}&goisi=${jikap}`).then(kip=>{
                let coun;
                let zoun;
                let soun;
                const yure = kip.data.yoso.map((cons,i)=>{
                    if(cons.parent == 0 && cons.depth > 0){
                        coun = cons.depth;
                        zoun = i + coun;
                        soun = false;
                    }else if(cons.parent > 0 && cons.depth == 0){
                        if(i == zoun){soun = true;}else{soun = false;};
                    }else if(cons.parent == 0 && cons.depth == 0){
                        coun = 0;
                        zoun = 0;
                        soun = false;
                    };
                    return {...cons, maruo : soun};
                });
                
                setpag({large : kip.data.zonche, list : yure});
            }).catch(err=>console.log("페이지네이션 오류"));
        };
        if(document.querySelector('.ants')){
            document.querySelector('.ants').remove();
        };
        
        fetch();
    },[single, jikap, ruru]);

      document.title = momo?.title + " - 돌파공모"
   
  

    const addnumber=()=>{
        setaddnum(addnum+1);
        setsingle(addnum*10+1);
        const kogaki = document.getElementById("miji");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    const minusnumber=()=>{
        setaddnum(addnum-1);
        setsingle((addnum-1)*10);
        const kogaki = document.getElementById("miji");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    let surren = null;
    let melod = null;
    const editt = (e,a,kk,vv)=>{
        const currentSpan = vv.currentTarget;
        const paho = currentSpan.closest('.daegu, .mdaegu').nextElementSibling;

        if(surren == null){
            vv.currentTarget.innerText = "\u21BA";
            surren = vv.currentTarget;
            melod = vv.currentTarget.parentElement.nextElementSibling;
        }else if(surren == vv.currentTarget){
            vv.currentTarget.innerText = '\u270E';
            surren = null;
            // document.querySelector('.ants').remove();
            paho.replaceWith(melod);
        }else{
            surren.innerText = '\u270E';
            vv.currentTarget.innerText = "\u21BA";
            const sonom = surren.closest('.daegu, .mdaegu').nextElementSibling;
            sonom.replaceWith(melod);
            surren = vv.currentTarget;
            melod = vv.currentTarget.parentElement.nextElementSibling;
        };
      
        if(paho && paho.className === 'daegk4'){
            const newDiv = document.createElement('div');
            newDiv.className = "kants";
            const kohoa = document.createElement('div');
            kohoa.className = isMobile ? 'mohoa2' : 'kohoa2';
    
    
            const kooo = document.createElement('div');
            kooo.id = 'mbbb';
            kooo.className = 'kohob';
            kooo.contentEditable = 'true';
            kooo.textContent = kk;
    
            const myca = document.createElement('div');
            myca.id = 'mycb';
            myca.className = 'kohoc1';
            myca.dataset.name = a;
            myca.dataset.mame = e;
            myca.addEventListener('click', kaca); 
    
    
            const pTag = document.createElement('p');
            pTag.textContent = '수정하기';
            pTag.className = isMobile ? 'mdapgo' : 'dapgo';
            myca.appendChild(pTag);
    
            kohoa.appendChild(kooo);
            kohoa.appendChild(myca);
            newDiv.appendChild(kohoa);

            paho.replaceWith(newDiv);
            kooo.focus();
        };
    };

    const gare = (cc, mm)=>{
        setdae(true);
        const currentSpan = cc.currentTarget;
        const paho = currentSpan.closest('.daegu').nextElementSibling;
        
        if(mm > 0){
            if(paho && paho.className === 'daegk4'){
                paho.dataset.cover = mm;
                setsiod(paho);
              
            };
        }else{
            if(paho && paho.className === 'daegk4'){
                paho.dataset.cover = mm;
                setsiod(paho);
                
            };
        };
    };

    const yido =(cons)=>{
        setsingle(cons);
        const kogaki = document.getElementById("miji");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    const jiwoon = async ()=>{
        
        if(siod){
            const shot = new FormData();
            shot.append('ssoo', siod.dataset.cover);
            
            const zoiu = await axios.post('/api/daetd',shot, {headers: {"Content-Type" : "multipart/form-data"}})
            .then(eah=>{ if(eah.data){setruru(prev=>prev+1);} }).catch(err=>{console.log("대댓글패22");}).finally(()=>{
                siod.textContent = "작성자에 의해 삭제합니다";
            });
        };
        setdae(false);
    };

    const riwoon=()=>{
        const scol = window.scrollY;
        const rath = encodeURIComponent(neyong.pathname + neyong.search);
       
        ngate(`/join?coin=${rath}&scol=${scol}`);
    };

    const clozz=()=>{
        setdae(false);
        setsiod(null);
    };

    const chani=()=>{
        setgamsa(false);
    };

    const vazz=(e)=>{
        e.preventDefault();
        // if(furi?.id){
        //     return;
        // };
        setgamsa(true);
    };

    return(
        <>
        <div className={isMobile ? 'ssoom' : 'smodda'}>
        <p className='modda submod'>{momo?.title}</p>
        <div className='munjin'><img src={process.env.PUBLIC_URL+`/document/${momo?.img}`} /></div>    
        <p>{dayjs(momo?.date).format("YY-MM-DD")} ~ {dayjs(momo?.end).format("YY-MM-DD")}</p>
        <p className={isMobile ? 'mabisi' : 'sabisi'}>관련사항</p>
     
        <div className='sorok sokak' dangerouslySetInnerHTML={{__html:momo?.content}}></div>
        </div>

        <Link to="/eika" onClick={()=>window.history.replaceState({page : window.history.state.page},null,null)} className='haolei saole'><span className='morok'>목록</span></Link>
        <div id="miji"></div>
    {pag?.list?.map((cons)=>{
                    const dayr = dayjs(cons.daytime).format("YYYY-MM-DD HH:mm:ss");
                  
                    return(
                        <>
                        {cons?.parent == 0 ? <Minis key={cons.num} keun={cons.num} moar={'mdaeg'} woar={'daeg'} cons={cons} dayr={dayr} editt={editt} gare={gare} rehello={rehello}/> : 
                        cons?.maruo ? <Minis key={cons.num} keun={cons.num} moar={'mdaeg ddaa'} woar={'daeg ddaa'} cons={cons} dayr={dayr} editt={editt} gare={gare} rehello={rehello}/> :
                        <Minis key={cons.num} keun={cons.num} moar={'mdaeg ddbb'} woar={'daeg ddbb'} cons={cons} dayr={dayr} editt={editt} gare={gare} rehello={rehello}/>
                        }
                        {/* {cons?.parent == 0 ? 
                            <div className={isMobile ? 'mdaeg' : 'daeg'} id={`b${i}`}>
                                <div className={isMobile ? 'mdaegu' : 'daegu'}>
                                <span className='daegk1'>{cons.name}</span>
                                <span className='daegk2'>{dayr}</span>
                                {cons.ban !== 1 && <span className='daegk3' onClick={(ev)=>rehello(cons.parent, cons.num, i, ev)}>&#x21B3;</span>}
                                {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(vv)=>editt(cons.parent, cons.num, cons.content, vv)}>&#x270E;</span>}
                                {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(cc)=>{gare(cc, cons.num)}}>&#x1F5D1;</span>}
                                </div>
                                <p className={cons.ban == 1 ? 'daegk4 daegb' : 'daegk4'} ref={komai}>{cons.content}</p>
                                {more && <p onClick={morelong}>{expn ? '접기' : '다보기'}</p>}
                               
                            </div> : cons?.maruo ? <div className={isMobile ? 'mdaeg ddaa' : 'daeg ddaa'} id={`b${i}`}>
                            <div className={isMobile ? 'mdaegu' : 'daegu'}>
                            <span className='daegk1'>{cons.name}</span>
                            <span className='daegk2'>{dayr}</span>
                            {cons.ban !== 1 && <span className='daegk3' onClick={(ev)=>rehello(cons.parent, cons.num, i, ev)}>&#x21B3;</span>}
                            {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(vv)=>editt(cons.parent, cons.num, cons.content, vv)}>&#x270E;</span>}
                            {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(cc)=>{gare(cc, cons.num)}}>&#x1F5D1;</span>}
                            </div>
                            <p className={cons.ban == 1 ? 'daegk4 daegb' : 'daegk4'} ref={komai}>{cons.content}</p>
                            {more && <p onClick={morelong}>{expn ? '접기' : '다보기'}</p>}
    
                        </div> : <div className={isMobile ? 'mdaeg ddbb' : 'daeg ddbb'} id={`b${i}`}>
                            <div className={isMobile ? 'mdaegu' : 'daegu'}>
                            <span className='daegk1'>{cons.name}</span>
                            <span className='daegk2'>{dayr}</span>
                            {cons.ban !== 1 && <span className='daegk3' onClick={(ev)=>rehello(cons.parent, cons.num, i, ev)}>&#x21B3;</span>}
                            {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(vv)=>editt(cons.parent, cons.num, cons.content, vv)}>&#x270E;</span>}
                            {furi?.id == cons.name && cons.ban !== 1 && <span className='daegk5' onClick={(cc)=>{gare(cc, cons.num)}}>&#x1F5D1;</span>}
                            </div>
                            <p className={cons.ban == 1 ? 'daegk4 daegb' : 'daegk4'} ref={komai}>{cons.content}</p>
                            {more && <p onClick={morelong}>{expn ? '접기' : '다보기'}</p>}
                        </div>
                        } */}
                    </>
                    ); 
                })} 

        <div className='badaku'>
            {addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
            {pag?.large /100 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
                return(<button onClick={()=>yido(cons)} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((pag?.large%100)/10)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
                   
                return(<button onClick={()=>yido(cons)} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
            {pag?.large > addnum*100 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
        </div>   
             
        <div className='mited'></div>
        <div className={isMobile ? 'mkohoa' : 'kohoa'}>
            <div contentEditable='true' id='kooo' onMouseDown={furi?.id ? null : vazz} placeholder={furi?.id ? '댓글, 작성할 수 있어요!' : '작성 전 로그인이 필요해요!'} className='kohob'></div>
            <div onClick={kono} id='mylif' className='kohoc'><p className={isMobile ? 'mdapgo' : 'dapgo'}>참여하기</p></div>
        </div>
        <div className='mited'></div>
        {pac?.has !== null && <div className={isMobile ? 'svous' : 'vous'}><span className='vous2'>이전글</span><span className='vous3'><Link to={`/eika/${pac?.has}`} state="undy" className='haolei'>{pac?.hus}</Link></span></div>}
        {pac?.las !== null && <div className={isMobile ? 'svous' : 'vous'}><span className='vous2'>다음글</span><span className='vous3'><Link to={`/eika/${pac?.las}`} state="undy" className='haolei'>{pac?.lus}</Link></span></div>} 
        <Nodal is="sakj" isOpen={dae} onClose={clozz} onConfirm={jiwoon} message="작성자에 의해 삭제합니다."/>   
        <Nodal is="rgin" isOpen={gamsa} onClose={chani} onConfirm={riwoon} message="로그인이 필요합니다."/>          
        </>
    )

}

export default Eoon;